import React, { useState } from 'react'
// eslint-disable-next-line
import { Mdx } from '@ta-interaktiv/contentbricks'
import { MiniVoting } from 'components/miniVoting'
import { QuestionObjectInterface } from 'types/index'
import { RelatedLinks } from 'components/relatedLinks'
import { Waypoint } from 'react-waypoint'
import '@ta-interaktiv/semantic-ui/semantic/dist/components/icon.css'
const debug = false
export interface QuestionProps {
  data: QuestionObjectInterface
  articleID: string
  isMobile?: boolean
}

export const Question = ({
  data,
  articleID,
  isMobile = false
}: QuestionProps) => {
  const [isActive, setActive] = useState(false)

  const toggle = () => {
    window.dataLayer.push({
      event: 'Interactions',
      event_action: 'click',
      event_label: 'question-clicked: ' + data.id
    })

    setActive(!isActive)
  }
  return (
    <>
      {data.id && <a id={data.id.toString()} />}
      {!isMobile && (
        <>
          <h4 className='ui header question'>
            <div className='qnumber'>{debug ? data.id : data.lastNum}</div>
            {data.q}
          </h4>
          <div className='answer'>
            <Mdx file={require('text/q_' + data.id + '.mdx')} />
          </div>
          <MiniVoting
            articleID={articleID}
            elementId={data.id}
            subject='50 Fragen zu Kopfschmerzen'
          />
          {data.related && (
            <RelatedLinks
              data={data.related.split(']')}
              title={data.relatedtitle}
            />
          )}
        </>
      )}
      {isMobile && (
        <>
          <div className={isActive ? 'active title' : 'title'} onClick={toggle}>
            <h4 className='ui header question'>
              <div className='qnumber'>{debug ? data.id : data.lastNum}</div>
              {data.q}
            </h4>{' '}
            <div className='openclose'>
              <i className={!isActive ? 'caret down icon' : 'close icon'} />
            </div>
          </div>
          <div className={isActive ? 'active content' : 'content'}>
            {/* eslint-disable-next-line */}
            <Mdx file={require('text/q_' + data.id + '.mdx')} />
            <MiniVoting
              articleID={articleID}
              elementId={data.id}
              subject='50 Fragen zu Kopfschmerzen'
            />
          </div>
        </>
      )}
    </>
  )
}
